
import { animatePopupOut } from '../../functions/animation.js';

export function createCloseButton(elem) {
    var closeButton = document.createElement('div');
    closeButton.id = 'close_button';
    closeButton.classList.add('close_button');
    var closeImage = document.createElement('img');
    closeImage.src = "assets/img/cross.png";

    closeButton.appendChild(closeImage);
    closeButton.addEventListener('mouseenter', () => {
        closeImage.src = 'assets/img/cross_hover.png';
      });
      closeButton.addEventListener('mouseleave', () => {
        closeImage.src = 'assets/img/cross.png';
      });
    closeButton.addEventListener('click', function() {
        console.log('close button clicked');
        animatePopupOut(elem);
        if (window.location.hash === '#more') {
            history.replaceState(null, null, ' ');
        }
        // Remove the popup element from the DOM
        var popup = document.getElementById('popup');
        popup.remove();
        overlay.remove();
    });
    elem.appendChild(closeButton);
    }
